// Yatay kaydırma kapsayıcısı, operatör ekranlarının elle yazılmış tabloları
// için (SEM-4931).
//
// Bir tablo sütun sayısı kadar geniştir ve sıkışamaz; kapsayıcısı yoksa taşmayı
// SAYFAYA devreder ve tabloyla ilgisi olmayan başlık, bant, kart hepsi birlikte
// kayar. Paylaşılan `@novemai/components` DataTable'ı aynı kutuyu kendi içinde
// kuruyor; bu ekranlar DataTable kullanmadığı için aynı KURALI paylaşıyorlar.
//
// `role="region"` bilerek YOK: etiketli ikinci bir yer işareti axe
// `landmark-unique` ihlali üretir (SEM-4928'de ölçüldü ve geri alındı).

export function TableScroll({
  children,
}: {
  readonly children: React.ReactNode;
}): React.ReactElement {
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- an overflow container needs a keyboard scroll target
    <div className="nai-data-table-scroll" tabIndex={0}>
      {children}
    </div>
  );
}
